import { TOOLS } from './tools';

export type PageLayoutWidth = 'full' | 'wide' | 'standard' | 'narrow';

export const LAYOUT_WIDTH_CLASSES: Record<PageLayoutWidth, string> = {
  full: 'max-w-[1440px] w-full',
  wide: 'max-w-7xl w-full',
  standard: 'max-w-5xl w-full',
  narrow: 'max-w-4xl w-full',
};

// Map of specific non-tool routes to layout widths
const STATIC_ROUTE_WIDTHS: Record<string, PageLayoutWidth> = {
  '/': 'full',
  '/all-tools': 'full',
  '/about': 'narrow',
  '/privacy': 'narrow',
  '/terms': 'narrow',
  '/changelog': 'full',
};

/**
 * Resolves the container layout width class for a given route path.
 */
export function getLayoutWidthForPath(pathname: string): PageLayoutWidth {
  const normalizedPath = pathname.replace(/\/$/, '') || '/';

  // Static content routes
  if (normalizedPath in STATIC_ROUTE_WIDTHS) {
    return STATIC_ROUTE_WIDTHS[normalizedPath];
  }

  // Find tool configuration
  const tool = TOOLS.find(
    (t) => t.path === normalizedPath || normalizedPath.startsWith(`${t.path}/`),
  );

  if (tool?.containerWidth) {
    return tool.containerWidth;
  }

  // Global standard: all tool workspaces use the full 1440px container width
  return 'full';
}

/**
 * Returns the tailwind class string for the layout container given a path.
 */
export function getLayoutContainerClass(pathname: string): string {
  const widthKey = getLayoutWidthForPath(pathname);
  return LAYOUT_WIDTH_CLASSES[widthKey];
}
